import { render, staticRenderFns } from "./PreRecordPage.vue?vue&type=template&id=c2c734ea&scoped=true&"
import script from "./PreRecordPage.vue?vue&type=script&lang=js&"
export * from "./PreRecordPage.vue?vue&type=script&lang=js&"
import style0 from "./PreRecordPage.vue?vue&type=style&index=0&id=c2c734ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c734ea",
  null
  
)

export default component.exports